import { getDestinationList } from '../../src/common/service/api/Destination/Destination';
import { GetStaticProps } from 'next';
import { LandmarkMainPage, LandmarkMainPageProps } from '@/screens/LandmarkMainPage/ui/LandmarkMainPage';
import { fetchAllLandmarks } from '@/screens/LandmarkMainPage/service/fetchAllLandmarks';
import { mapLandmarksByDestination } from '@/screens/LandmarkMainPage/service/mapLandmarksByDestination';

export const getStaticProps: GetStaticProps<LandmarkMainPageProps> = async () => {
    try {
        const [destinations, landmarks] = await Promise.all([
            getDestinationList(),
            fetchAllLandmarks()
        ]);

        const pageItems = mapLandmarksByDestination(landmarks, destinations.items);
        
        return {
            revalidate: Number(process.env.CACHE_ENV),
            props: {
                destinations: pageItems,
            },
        };
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export default LandmarkMainPage;
